<template>
    <MasterTemplate 
        title="ข้อมูลยี่ห้อรถ" 
        :headers="headers" 
        :setData="setData"
        itemKey="brandId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="รหัสยี่ห้อ" autofocus maxlength="20" v-model="editedItem.brandCode" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="8" >
                    <v-text-field  label="ชื่อยี่ห้อ" maxlength="100" v-model="editedItem.brandName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>

        </template>
    </MasterTemplate>


</template>

<script>
    import MasterTemplate from '@/components/MasterTemplate'
    import {listBrand, insertBrand, updateBrand, deleteBrand} from '@/api/master/brand-api.js'
    export default {
        components: {
            MasterTemplate
        },
        data: () => ({
                headers : [
                    {text: 'ชื่อยี่ห้อ', value: 'brandName'},
                    {text: 'รหัสยี่ห้อ', value: 'brandCode'},
                    {text: 'Actions', value: 'action', sortable: false}
                ],
                editedItem: {
                    brandId: '-1',
                    brandName: '',
                    brandCode: ''
                }
            
        }),
        methods: {
            listData() {
                return listBrand();
            },
            deleteData(item) {
            return deleteBrand(item.brandId);
            },
            insertData() {
                return insertBrand(this.editedItem);
            },
            updateData() {
                return updateBrand(this.editedItem);
            },
            getItemName(item) {
                return item.brandName;
            },
            setData(item) {
                this.editedItem = item;
            }

        }
    }
</script>